module.exports = __webpack_public_path__ + "images/application/i-cancel-41d766d2.svg";